/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiReqdfldgroup.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-reqdfldgroup";

export class AutogenModelEdiReqdfldgroup<RowType extends ModelRow> extends Endpoint<RowType, RowEdiReqdfldgroupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiReqdfldgroup extends ModelRow<RowEdiReqdfldgroupFields> {
	constructor(values?: Partial<RowEdiReqdfldgroupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiReqdfldgroupFields {
	company_id: string;
	descr: string;
	id: string;
	parent_row_id: string;
	parent_row_type: string;
	sequence: number;
}

